import assign from 'lodash.assign';
import "./style.scss";
import "./style.editor.scss";
import classnames from "classnames";
import { __ } from "@wordpress/i18n";
// import classNames from 'classnames';
const { createHigherOrderComponent } = wp.compose;
const { Fragment } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, ToggleControl, RangeControl, SelectControl} = wp.components;
const { addFilter } = wp.hooks;


// Enable Animate control on the following blocks
const enableSliderControlOnBlocks = [
    'core/gallery',
];


var sizeOptions = [
	{
		label: __( 'Full' ),
		value: 'full',
	},
	{
		label: __( 'Large' ),
		value: 'large',
	},
	{
		label: __( 'Regular' ),
		value: 'regular',
	},
	{
		label: __( 'Small' ),
		value: 'small',
	},
];

/**
 * Add Animate control attribute to block.
 *
 * @param {object} settings Current block settings.
 * @param {string} name Name of block.
 *
 * @returns {object} Modified block settings.
 */
const addSliderControlAttribute = ( settings, name ) => {
	// Do nothing if it's another block than our defined ones.
	if ( ! enableSliderControlOnBlocks.includes( name ) ) {
		return settings;
	}

	// Use Lodash's assign to gracefully handle if attributes are undefined
	settings.attributes = assign( settings.attributes, {
		slider: {
			type: 'boolean',
			default: false,
		},
        dots: {
			type: 'boolean',
			default: false,
			
		},
        auto: {
			type: 'boolean',
			default: false,
		},
        numberOfSlides: {
			type: 'number',
			default:  1,
		},
		size: {
			type: 'string',
			default: sizeOptions[ 0 ].value,
		},
	} );

	return settings;
};

addFilter( 'blocks.registerBlockType', 'extend-block-example/attribute/Animate', addSliderControlAttribute );

/**
 * Create HOC to add Animate control to inspector controls of block.
 */
const withAnimateControl = createHigherOrderComponent( ( BlockEdit, ) => {

	return ( props ) => {

		const {
			name,
			isSelected,
		} = props;
		const { slider, dots, auto, numberOfSlides, size} = props.attributes;



		return (
			<Fragment>
				<BlockEdit { ...props } />
				{ isSelected && enableSliderControlOnBlocks.includes( name ) &&
				<InspectorControls>
					<PanelBody
						title={ __( 'Slider Control' ) }
						initialOpen={ true }
					>
						<ToggleControl
							label={ __( 'Make Me Slider!' ) }
							checked={ slider }
							onChange={ ( selectedSliderOption ) => {
								props.setAttributes( {
									slider: selectedSliderOption,

								} );
							} }
						/>
						{slider &&
						<SelectControl
							label={ __( 'Size Settings', 'otter-animate-blocks' ) }
							help={ __( 'Sets Slider Size', 'otter-animate-blocks' ) }
							value={ size }
							options={ sizeOptions }
							onChange={ ( typeSelectedSizeOptions ) => {
								props.setAttributes( {
									size: typeSelectedSizeOptions,
								} );
							} }
						/>
					
						}
                        {slider &&
                        <ToggleControl
							label={ __( 'Dots' ) }
							checked={ dots }
							onChange={ ( selectedDotsOption ) => {
								props.setAttributes( {
									dots: selectedDotsOption,

								} );
							} }
						/>
                        }
                        {slider &&
                        <ToggleControl
							label={ __( 'Auto Play' ) }
							checked={ auto }
							onChange={ ( selectedAutoOption ) => {
								props.setAttributes( {
									auto: selectedAutoOption,

								} );
							} }
						/>
                        }
                        {slider &&
                        <RangeControl
							label={ __( 'Number of Images at one time' ) }
							value={ numberOfSlides }
							onChange={ ( rangNumberOption ) => {
								props.setAttributes( {
									numberOfSlides: rangNumberOption,
								} );
							} }
							min={ 1 }
							max={ 6 }
							step={1}
						/>
						}



					</PanelBody>
				</InspectorControls>
			}
			
			</Fragment>	
			
		);

	};
	
}, 'withSliderControl' );

addFilter( 'editor.BlockEdit', 'extend-block-example/with-slider-control', withAnimateControl );


/**
 * Add custom element class in save element.
 *
 * @param {Object} extraProps     Block element.
 * @param {Object} blockType      Blocks object.
 * @param {Object} attributes     Blocks attributes.
 *
 * @return {Object} extraProps Modified block element.
 */
 function applyExtraClass( extraProps, blockType, attributes ) {

	const {slider, dots, auto, numberOfSlides,size } = attributes;
	const classes =  classnames( {
		[`has-slider`]: slider,
        [`has-dots`]: dots,
        [`has-auto`]: auto,
		[`has-size-${size}`]: size,
        [`has-slides-${numberOfSlides}`]: numberOfSlides,
	});
	//check if attribute exists for old Gutenberg version compatibility
	//add class only when visibleOnMobile = false
	//add allowedBlocks restriction
	if ( slider === true && enableSliderControlOnBlocks.includes( blockType.name ))  {
		extraProps.className = classnames( extraProps.className, classes );
	}
	
	return extraProps;
	
}

addFilter(
	'blocks.getSaveContent.extraProps',
	'editorskit/applyExtraClass',
	applyExtraClass,
);